import { Box, Heading, Text } from '@chakra-ui/react';

import { BaseAccommodationInfoProps } from './base-accommodation-info.props';

export const BaseAccommodationInfo = ({ accommodationDetails }: BaseAccommodationInfoProps) => {
    return (
        <Box>
            <Heading as={'h2'} size={'md'}>
                {accommodationDetails.name}
            </Heading>
            <Text
                fontSize={{
                    base: 'sm',
                    lg: 'md',
                }}
                color={'gray.500'}
            >
                {accommodationDetails.address} {accommodationDetails.streetNumber}
            </Text>
        </Box>
    );
};
